import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/buttonIcons/sliderArrow.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/bnb.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/bonk.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/btc.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/doge.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/eth.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/euro.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/every.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/ltc.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/matic.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/shib.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/sol.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/ton.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/trx.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/usdc.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/usdt.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/wif.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/xrp.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/benefactor_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/entrepreneur_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/entrepreneur.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/investor_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/investor.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/jetsetter_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/jetsetter.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/landlord_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/landlord.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/magnate_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/mogul_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/mogul.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/owner_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/owner.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/paymentMethods/applepay.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/paymentMethods/gpay.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/paymentMethods/mastercard.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/paymentMethods/moonpayLogo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/paymentMethods/visa.svg");
